import React from 'react';
import OverAllPerformance from "../components/QuizResultScreen/overAllPerformance";
import TopicWiseAnalysis from "../components/Reports/topicWiseAnalysisReport";
import PracticeQuestionProgressStatusTab
    from "../components/PracticeQuestions/RightSection/PracticeQuestionProgressStatusTab";
import { useAnalyticsPageView, useTranslations, useReportsData } from "examsbook-react-sdk/custom-hooks";

/**
 * Reports page
 */

function Reports() {
    const t = useTranslations();
    useAnalyticsPageView();
    const { subjects, topicWiseAnalysisData, aggregateCount, accuracyCount, progressCount } = useReportsData();
    return (
        <React.Fragment>

            <div className="over-all-performance">
                <h3>{t('Overall_Performance')}</h3>
                <OverAllPerformance/>
            </div>
            {
                topicWiseAnalysisData && topicWiseAnalysisData.length > 0 ?
                    <div className="practice-banner topic-analysis">
                        <div className="overall-progress-status">
                            <div>
                                <h4>{t('Topic_wise_Analysis_of_completed_questions')}</h4>
                            </div>
                            <TopicWiseAnalysis topicWiseAnalysisData={topicWiseAnalysisData} subjects={subjects}/>
                        </div>
                    </div> : ''
            }
            <div className="practice-banner">
                <div className="overall-progress-status">
                    <PracticeQuestionProgressStatusTab subjects={subjects} aggregateCount={aggregateCount}
                                                       accuracyCount={accuracyCount} progressCount={progressCount}/>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Reports;
